/**=========================================================
 * Module: job.js
 * Job Controller
 =========================================================*/

 App.controller('JobController',
 ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', '$sce', '$element', 'ngDialog', '$http',
 function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $sce, $element, ngDialog, $http) {
   "use strict";

   
   FIREBASE.listen('jobs', $scope.jid, function(value){
       if(value){
           $timeout(function(){
               $scope.progress = value.progress.total ? Math.round(value.progress.current/value.progress.total*100) : 0
           }, 0)
           if(value.status=='completed'){

           }
       }
   })


 }
 ]);
